/* eslint-disable no-unused-vars */
import React,{ useCallback, useEffect, useState }  from 'react';
import { message, Table } from "antd";
import Header from '../Header';
import Sidebar from '../Sidebar';
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

import {onShowSizeChange,itemRender}from  '../Pagination'
import { blogimg10, imagesend, pdficon, pdficon3, pdficon4, plusicon, refreshicon, searchnormal, blogimg12,
     blogimg2, blogimg4, blogimg6, blogimg8,
     male,
     female} from '../imagepath';
import { Link } from 'react-router-dom';
import AddPatientPopup from '../appointmentBooking/AddPatientPopUp';
import { SearchOutlined } from '@ant-design/icons';
import { getPatientList } from '../../services/receptionist/patient/patient';
import Loader from '../Loader';

const PatientsList = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [addPatientShow, setAddPatientShow] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);
    const [EditShow, SetEditShow] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null); 
    const [searchKeyword, setSearchKeyword] = useState("");
    const [refresh, setRefresh] = useState(false);
    const {messageApi, context} = message.useMessage();



    const onSelectChange = (newSelectedRowKeys) => {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      setSelectedRowKeys(newSelectedRowKeys);
    };
    const handleClosePopup = useCallback(() => {
      setAddPatientShow(false)
      SetEditShow(false)
    }, [])

    

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const fetchPatients = async () => {
      setLoading(true);
      try {
        const result = await getPatientList(searchKeyword);
        if (result.success) {
          console.log("Fetched Data:", result.data);
          const formData=result?.data;
          console.log("Formatted Data:", formData);
          setDataSource(formData);
        } else {
          console.error("Error:", result.error || "Failed to fetch hospitals");
        }
      } catch (err) {
        console.error("Exception:", err.message);
      } finally {
        setLoading(false);
      }
    };
    const columns = [
      {
          title: "Name",
          dataIndex: "Name",
          render: (text, record) => (
              <>
                  <h2 className="profile-image">
                      <Link to="#" className="avatar avatar-sm me-2">
                          
                          
                            <img
                              className="avatar-img rounded-circle"
                              src={record.gender == "Male" ? male : female}
                              alt="User Image"
                          />
                      </Link>
                      <Link to="#">{record.first_name}  {record.last_name}</Link>
                  </h2>

              </>
          ),
          // sorter: (a, b) => a.first_name.length - b.first_name.length
      },
      
      {
          title:"Mobile",
          dataIndex: "Mobile",
              // sorter: (a, b) => a.Mobile.length - b.Mobile.length,
              render: (text, record) => (
                  <>
                          <Link to="#">{record.mobile}</Link>
                  </>
              )
      }, {
          title:"Email",
          dataIndex: "office_id",
              // sorter: (a, b) => a.email.length - b.email.length
      },
      //  {
      //     title:"Hospital",
      //     dataIndex: "hospital",
      //         sorter: (a, b) => a.Email.length - b.Email.length
      // },
       {
          title:"Status",
          dataIndex: "status",
              // sorter: (a, b) => a.Email.length - b.Email.length
      },

      {
        title: "",
        dataIndex: "FIELD8",
        render: (text, record) => (
          <>
            <div className="text-end">
              <div className="dropdown dropdown-action">
                <Link
                  to="#"
                  className="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fas fa-ellipsis-v" />
                </Link>
                <div className="dropdown-menu dropdown-menu-end">
                  <Link className="dropdown-item" to="/patient-profile" state={{ patient : record }}>
                    <i className="fa-solid fa-user-doctor me-2" />
                    View Profile
                  </Link>
                  <Link className="dropdown-item" onClick={()=>{SetEditShow(true),setSelectedPatient(record)}} >
                    <i className="far fa-edit me-2" />
                    Edit
                  </Link>
                  <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_patient">
                     <i className="fa fa-trash-alt m-r-5"></i> Delete</Link>
                </div>
              </div>
            </div>
          </>
        ),
      },
  ]
  useEffect(() => {
    fetchPatients();
  }, [refresh,searchKeyword,addPatientShow,EditShow]);

  return (
    <>
    
    {context}
    <Header />
    <Sidebar  activeClassName='patient' />

    
  <div className="page-wrapper">
    <div className="content">
      {/* Page Header */}
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="#">Patients  </Link>
              </li>
              <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
              <li className="breadcrumb-item active"> Patients List</li>
            </ul>
          </div>
        </div>
      </div>
      {/* /Page Header */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              {/* Table Header */}
              <div className="page-table-header mb-2">
                <div className="row align-items-center">
                  <div className="col">
                    <div className="doctor-table-blk">
                      <h3>Patients List</h3>
                      <div className="doctor-search-blk">
                        <div className="top-nav-search table-search-blk">
                          <form>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search here"
                              onChange={(e) => {setSearchKeyword(e.target.value)}}
                            />
                             <Link className="btn"  onClick={(e)=>fetchPatients()} style={{color:"#2e37a4",fontWeight: "bold"}}>
                            <SearchOutlined style={{ fontSize: "18px",fontWeight: "bold" }}/>
                            </Link>
                          </form>
                        </div>
                        <div className="add-group">
                          <Link
                          //  to="/addpatients"
                          onClick={() => setAddPatientShow(true)}
                            className="btn btn-primary add-pluss ms-2"
                          >

                            <img src={plusicon} alt="#" />
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-primary doctor-refresh ms-2"
                            onClick={(e) => setRefresh(!refresh)}
                          >
                            <img src={refreshicon}alt="#" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-auto text-end float-end ms-auto download-grp">
                    <Link to="#" className=" me-2">
                      <img src={pdficon} alt="#" />
                    </Link>
                    <Link to="#" className=" me-2">
                    </Link>
                    <Link to="#" className=" me-2">
                      <img src={pdficon3} alt="#" />
                    </Link>
                    <Link to="#">
                      <img src={pdficon4} alt="#" />
                    </Link>
                  </div> */}
                </div>
              </div>
              {/* /Table Header */}
              <div className="table-responsive doctor-list">
              {loading ?
                        <Loader/>
                      :
              <Table
                        pagination={{
                          total: dataSource.length,
                          showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          // showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                      
                          itemRender: itemRender,
                          style: { paddingRight: "14px" },
                        }}
                        columns={columns}
                        dataSource={dataSource}
                        
                        rowSelection={rowSelection}
                        rowKey={(record) => record.id}
                      />
              }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  {addPatientShow && <AddPatientPopup show={addPatientShow} handleClose={handleClosePopup} />}
  {EditShow && <AddPatientPopup show={EditShow} handleClose={handleClosePopup} editpatientsdetail={selectedPatient} />}
</>

  )
}

export default PatientsList;
